import { render } from "./ThreePeople.vue?vue&type=template&id=7fd3e18a&scoped=true"
import script from "./ThreePeople.vue?vue&type=script&lang=js"
export * from "./ThreePeople.vue?vue&type=script&lang=js"

import "./ThreePeople.vue?vue&type=style&index=0&id=7fd3e18a&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd3e18a"]])

export default __exports__